// extracted by mini-css-extract-plugin
module.exports = {"container":"sceneNotice_container__JKTsS","notice":"sceneNotice_notice__3zlo4"};